import React, { useState, useEffect } from "react";
import { Button } from "../../../atoms";
import "./subscription-failure.m.css";

export function SubscriptionFailure() {
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const error = searchParams.get("errorMsg");
    console.log("FAILURE LOG ----", searchParams, error);
    setErrorMessage(error || "Something went wrong.");
  }, []);

  return (
    <div styleName="container">
      <div styleName="message-section">
        <p styleName="title">{errorMessage}</p>
      </div>
      <div styleName="action-buttons">
        <Button href="/" customStyleName="bg-brand-primary">
          Go to Home
        </Button>
        <Button href="/profile" customStyleName="">
          Go to Profile
        </Button>
      </div>
    </div>
  );
}
